<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option value="">全部</a-select-option>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">
              <a-tree-select
                :tree-data="zoneTreeData"
                v-model="query.zoneId"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                placeholder="请选择片区"
                allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                show-search
                treeNodeFilterProp="title"
              ></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="16" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>

              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px">
                <a
                  href="https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2024-11-19/c2c93b9648ba46a2838c683a49659e1c.xlsx"
                  >模板下载</a
                >
              </a-button>

              <a-button type="primary" style="margin-left: 8px" @click="exportHandle">导出</a-button>

              <a-upload
                name="file"
                :multiple="false"
                @change="changeFile"
                :file-list="fileList"
                :customRequest="customRequest"
              >
                <a-button style="margin-left: 8px" type="primary" :loading="importLoading">导入</a-button>
              </a-upload>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="type" slot-scope="text">
        <a-tag v-if="text === 0" color="#125da3">夜间</a-tag>
        <a-tag v-if="text === 1" color="rgb(45, 183, 245)">日间</a-tag>
        <a-tag v-if="text === 2" color="rgb(16, 142, 233)">大屏</a-tag>
      </span>
      <span slot="label" slot-scope="text1">{{ moment(text1).format('HH:mm:ss') }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal
      title="新增"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="addhandleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addForm" ref="addForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域id" hidden>
          <a-input v-decorator="['oldZoneId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select
            :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]"
            style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择片区"
            allow-clear
            :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
            show-search
            treeNodeFilterProp="title"
          ></a-tree-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="流量类型">
          <a-select
            placeholder="流量类型"
            style="width: 200px"
            @change="typeChange"
            v-decorator="['type', { initialValue: 0, rules: [{ required: true, message: '请选择流量类型' }] }]"
          >
            <a-select-option :value="0">夜间类型</a-select-option>
            <a-select-option :value="1">日间类型</a-select-option>
            <a-select-option :value="2">大屏2-5时总流量</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置时间段方式">
          <a-radio-group v-model="settimeway">
            <a-radio :value="0">系统设置</a-radio>
            <a-radio :value="1">自定义</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-row style="margin-left: 75px; position: relative" v-for="(item, i) in sjdckzarr" :key="i">
          <span style="color: red; position: absolute; left: 15px; top: 11px">*</span>
          <a-col :span="14">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间段">
              <a-select
                v-if="settimeway == 0"
                placeholder="时间段"
                style="width: 100px"
                @change="timechange"
                v-model="item.labelStr"
              >
                <a-select-option :value="item" v-for="(item, i) in hourarr" :key="i">{{ item }}</a-select-option>
              </a-select>
              <a-input
                v-else
                v-model="item.labelStr"
                style="width: 100px"
                placeholder="请输入"
                @blur="handletime1Blur(item.labelStr, i)"
              />

              <span style="background-color: #ededed; padding: 6px 8px; margin-left: 15px">
                {{
                  item.labelStr +
                  ':00 ~ ' +
                  (Number(Number(item.labelStr) + 1) < 10
                    ? '0' + Number(Number(item.labelStr) + 1)
                    : Number(Number(item.labelStr) + 1)) +
                  ':00'
                }}</span
              >
            </a-form-item>
          </a-col>
          <span style="color: red; position: absolute; right: 285px; top: 11px">*</span>

          <a-col :span="10">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考值">
              <a-input v-model="item.value" style="width: 100px" />
              <img
                src="@/assets/partition/differentRules/add.png"
                style="margin-left: 15px; cursor: pointer"
                @click="addsjdckzarr"
                v-if="i == 0"
              />
              <img
                src="@/assets/partition/differentRules/minus.png"
                style="margin-left: 15px; cursor: pointer"
                @click="minussjdckzarr(i)"
                v-else
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal title="编辑" style="top: 20px" :width="800" v-model="UpdateVisible" @ok="handleOk" @cancel="handleCancel">
      <a-form class="tenant-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域id" hidden>
          <a-input v-decorator="['oldZoneId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
          <a-tree-select
            :tree-data="zoneTreeData"
            v-decorator="['zoneId', { rules: [{ required: true, message: '请选择片区' }] }]"
            style="width: 100%"
            :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择片区"
            allow-clear
            :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
            show-search
            treeNodeFilterProp="title"
          ></a-tree-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="流量类型">
          <a-select
            placeholder="流量类型"
            style="width: 200px"
            @change="typeChange"
            v-decorator="['type', { initialValue: 0, rules: [{ required: true, message: '请选择流量类型' }] }]"
          >
            <a-select-option :value="0">夜间类型</a-select-option>
            <a-select-option :value="1">日间类型</a-select-option>
            <a-select-option :value="2">大屏2-5时总流量</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设置时间段方式">
          <a-radio-group v-model="settimeway">
            <a-radio :value="0">系统设置</a-radio>
            <a-radio :value="1">自定义</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="时间段">
          <a-select
            v-if="settimeway == 0"
            placeholder="时间段"
            style="width: 200px"
            @change="timechange"
            v-decorator="['labelStr', { initialValue: 19, rules: [{ required: true, message: '请选择时间段' }] }]"
          >
            <a-select-option :value="item" v-for="(item, i) in hourarr" :key="i">{{ item }}</a-select-option>
          </a-select>
          <a-input
            v-else
            v-decorator="['labelStr']"
            style="width: 100px"
            placeholder="请输入"
            @blur="handletime2Blur()"
          />
          <span style="background-color: #ededed; padding: 6px 8px; margin-left: 15px"> {{ timeinterval }}</span>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考值">
          <a-input v-decorator="['value', { rules: [{ required: true, message: '请输入参考值' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import moment from 'moment'
const columns = [
  {
    title: '区域名称',
    dataIndex: 'zoneName',
  },
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '时间',
    dataIndex: 'label',
    scopedSlots: { customRender: 'label' },
  },
  {
    title: '参考值',
    dataIndex: 'value',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'DifferentRules',
  data() {
    return {
      settimeway: 0,
      sjdckzarr: [{ labelStr: 19, value: '' }],
      tenantList: [],
      fileList: [],
      importLoading: false,
      queryUrl: 'pipe-network/difference-rule',
      addOrUpdateUrl: 'pipe-network/difference-rule',
      deleteUrl: 'pipe-network/difference-rule',
      // exportDataUrl: '/pipe-network/difference-rule/import',
      exportDataUrl: `pipe-network/difference-rule/export`,
      queryOneUrl: 'pipe-network/difference-rule',
      //   downloadTemplateUrl: 'zone-metering/calculate-rule/template/download',
      //   downloadTemplateName: '各片区关联水表导入模板.xlsx',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      query: {
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
      },
      UpdateVisible: false,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      addForm: this.$form.createForm(this, { name: 'add' }),

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      zoneTreeData: [], // 片区选项
      oldZoneId: '',
      treeDefaultExpandedKeys: [], //默认展开的树节点
      hourarr: ['19', '20', '21', '22',  '00', '01', '02', '03', '04', '05'],
      timeinterval: '',
    }
  },
  computed: {
    rules() {
      return {
        labelStr: [
          { required: true, message: '请输入时间段', trigger: 'change' },
          { pattern: /^(?:[1-9]\d?|[1234]\d{2}|500)$/, message: '请输入正整数', trigger: 'change' },
        ],
      }
    },
  },
  watch: {
    addOrUpdateVisible(val) {
      if (!val) {
        this.sjdckzarr = [{ labelStr: '19', value: '' }]
      }
    },
  },
  filters: {
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    this.getZoneData()
    this.getAllTenant()
    this.resetList()
  },
  methods: {
    handletime1Blur(number, i) {
      // 禁止输入23
      if (number === '23') {
        this.sjdckzarr[i].labelStr = ''
        return this.$message.warn('不能输入23点！')
      }
      if (/^([01]?[0-9]|2[0-2])$/.test(number)) {
        if (number < 10 && number.length == 1) {
          this.sjdckzarr[i].labelStr = '0' + number
        }
      } else {
        this.sjdckzarr[i].labelStr = ''
        return this.$message.warn('请输入0-22之间的正确时间！')
      }
    },
    handletime2Blur() {
      let number = this.addOrUpdateForm.getFieldValue('labelStr')
      // 禁止输入23
      if (number === '23') {
        this.addOrUpdateForm.setFieldsValue({ labelStr: '' })
        return this.$message.warn('不能输入23点！')
      }
      if (/^([01]?[0-9]|2[0-2])$/.test(number)) {
        if (number < 10 && number.length == 1) {
          this.addOrUpdateForm.setFieldsValue({ labelStr: '0' + number })
        }
      } else {
        this.addOrUpdateForm.setFieldsValue({ labelStr: '' })
        return this.$message.warn('请输入0-22之间的正确时间！')
      }
    },
    addhandleOk(e) {
      e.preventDefault()

      let isnull = ''
      this.addForm.validateFields((err, values) => {
        if (!err) {
          var params = []
          let labelStrarr = []
          this.sjdckzarr.map((item) => {
            if (!item.value) {
              isnull = true
            }
            labelStrarr.push(item.labelStr)
            params.push({
              labelStr: item.labelStr + ':00:00',
              value: item.value,
              ...values,
            })
          })

          if (this.isRepeat(labelStrarr)) {
            return this.$message.warn('时间段不能重复!')
          }
          if (isnull) {
            return this.$message.warn('参考值不能为空!')
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.addOrUpdateForm.setFieldsValue({ type: 0 })

                this.sjdckzarr = [{ labelStr: '19', value: '' }]

                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          ;(values.labelStr = values.labelStr + ':00:00'),
            this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, { id: this.currentId, ...values })
              .then((res) => {
                if (res.code === 0) {
                  this.UpdateVisible = false
                  this.queryList()
                  return this.$message.success(res.message)
                }
              })
              .catch(() => {})
        }
      })
    },
    customRequest(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    changeFile(info) {
      // 上传文件
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/difference-rule/import/zone',
        headers: {},
        params: {},
        data: formData,
      })
        .then((response) => {
          if (response.code === 0) {
            this.queryList()
            this.$message.success(response.message)
          }
          this.importLoading = false
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    addsjdckzarr() {
      if (this.sjdckzarr.length >= 5) {
        return this.$message.warn('最多只能添加5条!')
      }
      let type = this.addForm.getFieldValue('type')
      if (type == 0) {
        this.sjdckzarr.push({ labelStr: '19', value: '' })
      } else if (type == 1) {
        this.sjdckzarr.push({ labelStr: '06', value: '' })
      } else if (type == 2) {
        this.sjdckzarr.push({ labelStr: '02', value: '' })
      }
    },
    isRepeat(arr) {
      var hash = {}

      for (var i in arr) {
        if (hash[arr[i]]) return true

        hash[arr[i]] = true
      }

      return false
    },
    minussjdckzarr(i) {
      this.sjdckzarr.splice(i, 1)
    },
    typeChange(val) {
      if (val == 0) {
        this.hourarr = ['19', '20', '21', '22',  '00', '01', '02', '03', '04', '05']
        this.sjdckzarr = [{ labelStr: 19, value: '' }]
        this.addOrUpdateForm.setFieldsValue({ labelStr: '19' })

        this.addForm.setFieldsValue({ labelStr: '19' })

        this.timechange('19')
      } else if (val == 1) {
        this.hourarr = ['06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18']
        this.sjdckzarr = [{ labelStr: '06', value: '' }]
        this.addOrUpdateForm.setFieldsValue({ labelStr: '06' })
        this.addForm.setFieldsValue({ labelStr: '06' })

        this.timechange('06')
      } else if (val == 2) {
        this.hourarr = ['02', '03', '04', '05']
        this.sjdckzarr = [{ labelStr: '02', value: '' }]
        this.addOrUpdateForm.setFieldsValue({ labelStr: '02' })
        this.addForm.setFieldsValue({ labelStr: '02' })

        this.timechange('02')
      }
    },
    timechange(time) {
      time = Number(time)

      if (time + 1 < 10) {
        this.timeinterval = '0' + time + ':00 ~ ' + '0' + (time + 1) + ':00'
      } else {
        this.timeinterval = time + ':00 ~ ' + (time + 1) + ':00'
      }
    },
    resetList() {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRowKeys = []
      this.queryList()
    },
    moment,
    addOrUpdateHandle(id) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addForm.resetFields()

      if (id) {
        this.UpdateVisible = true
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            // data.label ? data.labelStr = moment(data.label).format('HH:mm:ss') : ''
            data.labelStr = data.label.hour < 10 ? '0' + data.label.hour : data.label.hour
            this.typeChange(data.type)
            this.$nextTick(() => {
              let time = Number(data.labelStr)
              if (time + 1 < 10) {
                this.timeinterval = '0' + time + ':00 ~ ' + '0' + (time + 1) + ':00'
              } else {
                this.timeinterval = time + ':00 ~ ' + (time + 1) + ':00'
              }
            })
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => {})
      } else {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          let time = this.addForm.getFieldValue('labelStr')

          if (Number(time) + 1 < 10) {
            this.timeinterval = '0' + Number(time) + ':00 ~ ' + '0' + Number(time + 1) + ':00'
          } else {
            this.timeinterval = Number(time) + ':00 ~ ' + Number(time + 1) + ':00'
          }
        })
      }
    },
    getAllTenant() {
      if (this.$store.state.user.info.systemAdmin) {
        this.$http
          .get('/manager/tenants/all')
          .then(({ data }) => {
            this.tenantList = data
          })
          .catch(({ e }) => {
            console.log(e)
          })
      }
    },
    onChange(time, timeString) {
      this.label = timeString
    },
    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
        this.chuli(this.zoneTreeData)
      })
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
